export default {
  "icon": "_icon_a6tn0_1",
  "icon--active": "_icon--active_a6tn0_1"
};import "ni:sha-256;gIKgPEKddMkodYIorGyktfRMacey1GNoa9HOKha7lW4";